import React from 'react';

export default function EpobsDailyFeeTerms() {
  return (
    <>
      <p
        style={{
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        <a id="_t7wkvx420ffu" />
        EPOBS Daily Fee Collection System (EDCS) is a robust cloud-based school
        daily fee collection System. The software has been designed to feature
        unparalleled flexibility &amp; scalability, intuitive visuals and
        dashboards supported by comprehensive drill-down capabilities to perform
        different tasks and generate appropriate report types.
      </p>
      <p
        style={{
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        It is developed by technological experts garnered for years and
        specialists drawn from diverse fields of Academia and financial
        management, with in-depth understanding of School’s requirements
        regarding daily collection of fees in both private and public schools in
        Ghana.
      </p>
      <p>&nbsp;</p>
      <p
        style={{
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        <strong>
          PLEASE READ THE BELOW TERMS AND CONDITIONS CAREFULLY.&nbsp;
        </strong>
      </p>
      <p
        style={{
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        <strong>
          By accessing or using the EPOBS Daily Fee Collection Module, you agree
          to these terms and conditions.&nbsp;
        </strong>
      </p>
      <p>&nbsp;</p>
      <ol style={{ margin: '0pt', paddingLeft: '0pt' }}>
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '15.63pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '2.37pt',
            fontSize: '14pt',
            color: '#16587d',
          }}
        >
          TERMS OF USE
          <span
            style={{ lineHeight: '108%', fontSize: '16pt', color: '#2f5496' }}
          >
            &nbsp;&nbsp;
          </span>
        </li>
      </ol>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'center',
          lineHeight: 'normal',
        }}
      >
        &nbsp;
      </p>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginBottom: '7.5pt',
            textAlign: 'justify',
            lineHeight: '115%',
            listStylePosition: 'inside',
          }}
        >
          <span
            style={{
              width: '25.7pt',
              font: '7pt "Times New Roman"',
              display: 'inline-block',
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          These Terms of Use ("TOU") along with the corresponding Order Form (as
          defined below in section 1.5) constitute an agreement (the
          "Agreement") by and between your
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          institution&nbsp; (“Customer”) and EPOBS, a Ghanaian limited liability
          company ("EPOBS").
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Customer's use of and EPOBS' provision of EPOBS' System and Service
          (as defined below
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          in Section 1.8) are governed by this Agreement.
        </li>
        <li
          style={{
            marginBottom: '7.5pt',
            textAlign: 'justify',
            lineHeight: '115%',
            listStylePosition: 'inside',
          }}
        >
          <span
            style={{
              width: '23.17pt',
              font: '7pt "Times New Roman"',
              display: 'inline-block',
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          You consent that the EPOBS DAILY FEE COLLECTION SYSTEM (EDCS) is an
          independent module, and is subscribed to separately of the other
          modules of the EPOBS suite.
        </li>
        <li
          style={{
            marginBottom: '7.5pt',
            textAlign: 'justify',
            lineHeight: '115%',
            listStylePosition: 'inside',
          }}
        >
          <span
            style={{
              width: '20.65pt',
              font: '7pt "Times New Roman"',
              display: 'inline-block',
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          You consent that subscription to the other modules of the EPOBS suite
          does NOT warrant an access to the EDCS, and subscription to the EDCS
          does NOT warrant access
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          to the other modules of the EPOBS suite.
        </li>
        <li
          style={{
            marginBottom: '7.5pt',
            textAlign: 'justify',
            lineHeight: '115%',
            listStylePosition: 'inside',
          }}
        >
          <span
            style={{
              width: '20.73pt',
              font: '7pt "Times New Roman"',
              display: 'inline-block',
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          Subscription is based on the number of students in your institution,
          and other conditions as may be agreed with EPOBS.
        </li>
        <li
          style={{
            marginBottom: '7.5pt',
            textAlign: 'justify',
            lineHeight: '115%',
            listStylePosition: 'inside',
          }}
        >
          <span
            style={{
              width: '23.25pt',
              font: '7pt "Times New Roman"',
              display: 'inline-block',
            }}
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          You consent that you UNDERSTANDS this Terms and Conditions, AND AGREES
          TO BE BOUND BY ITS TERMS, AND THAT THE PERSON BINDING THE CUSTOMER HAS
          BEEN AUTHORIZED TO DO SO. THESE TERMS AND CONDITIONS SHALL CONTROL THE
          RIGHTS AND OBLIGATIONS OF THE PARTIES UNLESS AN INDIVIDUALLY
          NEGOTIATED SOFTWARE AS A SERVICE AGREEMENT IS AGREED UPON IN WRITING."
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '10.55pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          DEFINITIONS. The following capitalized terms shall have the following
          meanings whenever used in this Agreement.
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '10.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '3.2pt',
          }}
        >
          "
          <strong>
            <u>AUP</u>
          </strong>
          " means EPOBS' Acceptable Use Policy currently posted at&nbsp;
          <a
            href="https://www.epobssolutions.com/terms/aup"
            style={{ textDecoration: 'none' }}
          >
            <u>
              <span style={{ color: '#0000ff' }}>
                https://www.epobssolutions.com/terms/aup
              </span>
            </u>
          </a>
          .
        </li>
        <li
          style={{
            marginLeft: '12.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '0.67pt',
          }}
        >
          "
          <strong>
            <u>Customer's Clients</u>
          </strong>
          " means any of Customer's clients, members, or customers or other
          third parties Customer gives access to the System, including without
          limitation such organizations' and/or institutions’ agents and
          employees.
        </li>
        <li
          style={{
            marginLeft: '13.5pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>Customer Data</u>
          </strong>
          " means data in electronic form input or collected through the EPOBS
          app by or from Customer, including without limitation by Customer's
          Clients, by other Users, and by Customer's Clients' own customers.
        </li>
        <li
          style={{
            marginLeft: '13.5pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>Documentation</u>
          </strong>
          " means EPOBS' standard manual related to use of the System.
        </li>
        <li
          style={{
            marginLeft: '12.75pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '0.75pt',
          }}
        >
          "
          <strong>
            <u>Order Form</u>
          </strong>
          " means an Order Form or Subscription Page for access to the System,
          executed as follows: via electronic or regular signature or by
          processing payment through the Subscription Page.
        </li>
        <li
          style={{
            marginLeft: '13.5pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>Privacy Policy</u>
          </strong>
          " means EPOBS' privacy policy, currently posted at{' '}
          <a
            href="https://www.epobssolutions.com/privacyp"
            style={{ textDecoration: 'none' }}
          >
            <u>
              <span style={{ color: '#0000ff' }}>
                https://www.epobssolutions.com/privacy
              </span>
            </u>
          </a>{' '}
          <a
            href="https://www.aplos.com/privacy"
            style={{ textDecoration: 'none' }}
          >
            <span style={{ color: '#000000' }}>&nbsp;</span>
          </a>
        </li>
        <li
          style={{
            marginLeft: '13.5pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>Subscription Page</u>
          </strong>
          " means the web page that is used to sign up and purchase a
          subscription to the EPOBS Daily Fee Payment System.&nbsp;&nbsp;
        </li>
      </ol>
      <p
        style={{
          marginLeft: '13.5pt',
          marginBottom: '0pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        &nbsp; and software.
      </p>
      <ol
        start={8}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '18pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>Term</u>
          </strong>
          " is defined in Section 11.1 below.
        </li>
        <li
          style={{
            marginLeft: '13.5pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          "
          <strong>
            <u>User</u>
          </strong>
          " means any company or individual who uses the EPOBS app on Customer's
          behalf or through Customer's accounts or passwords, whether authorized
          or not or through an account created by Customer for the use of
          another.
        </li>
      </ol>
      <ol
        start={2}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '13.58pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Customer's Responsibilities &amp; Restrictions.
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '10.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>Acceptable Use</u>
          </strong>
          . Customer shall comply with the AUP. Customer shall not: (a) use the
          System for service bureau or time-sharing purposes or in any other way
          allow third parties to exploit the System; (b) provide System
          passwords or other log-in information to any third party; (c) share
          non-public System features or content with any third party; (d) access
          the System in order to build a competitive product or service, to
          build a product using similar ideas, features, functions or graphics,
          or to copy any ideas, features, functions or graphics of the System;
          or (e) engage in web scraping or data scraping on or related to the
          System, including without limitation collection of information through
          any software that simulates human activity or any bot or web crawler.
          If it suspects any breach of the requirements of this Section 5.1,
          including without limitation by Users, EPOBS may suspend Customer's
          access to the System without advanced notice, in addition to such
          other remedies as EPOBS may have. Neither this Agreement nor the AUP
          requires that EPOBS take any action against Customer or any User or
          other third party for violating the AUP, this Section 5.1, or this
          Agreement, but EPOBS is free to take any such action it sees fit.
        </li>
        <li
          style={{
            marginLeft: '12.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>Unauthorized Access</u>
          </strong>
          . Customer shall take reasonable steps to prevent unauthorized access
          to the System, including without limitation by protecting its
          passwords and other log-in information. Customer shall notify EPOBS
          immediately of any known or suspected unauthorized use of the System
          or breach of its security and shall use best efforts to stop said
          breach.
        </li>
        <li
          style={{
            marginLeft: '15.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Compliance with Laws</u>
          </strong>
          . In its use of the System, Customer shall comply with all applicable
          laws, including without limitation laws governing the protection of
          personally identifiable information and other laws applicable to the
          protection of Customer Data in Ghana.
        </li>
        <li
          style={{
            marginLeft: '15.27pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.73pt',
          }}
        >
          <strong>
            <u>Customer's Users; System Access</u>
          </strong>
          . Customer is responsible and liable for: (a) Customer's Users' use of
          the System, including without limitation unauthorized User conduct and
          any User conduct that would violate the AUP or the requirements of
          this Agreement applicable to Customer; and (b) any use of the System
          through Customer's account, whether authorized or unauthorized.
        </li>
      </ol>
      <ol
        start={3}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '16.6pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          IP &amp; Feedback.
          <ol
            style={{
              marginRight: '0pt',
              marginLeft: '0pt',
              paddingLeft: '0pt',
              listStyleType: 'lower-roman',
            }}
          >
            <li
              style={{
                marginLeft: '-6.3pt',
                marginBottom: '0pt',
                lineHeight: '115%',
                paddingLeft: '7.7pt',
                fontSize: '11pt',
                color: '#000000',
              }}
            >
              <strong>
                <u>IP Rights to the System</u>
              </strong>
              . EPOBS retains all right, title, and interest in and to the
              System, including without limitation all software used to provide
              the System and all graphics, user interfaces, logos, and
              trademarks reproduced through the System. This Agreement does not
              grant the Customer any intellectual property license or rights in
              or to the System or any of its components. Customer recognizes
              that the System and its components are protected by copyright and
              other laws.
            </li>
            <li
              style={{
                marginLeft: '-3.77pt',
                marginBottom: '0pt',
                lineHeight: '115%',
                paddingLeft: '5.17pt',
                fontSize: '11pt',
                color: '#000000',
              }}
            >
              <strong>
                <u>Feedback</u>
              </strong>
              . EPOBS has not agreed to and does not agree to treat as
              confidential any Feedback (as defined below) Customer or Users
              provide to EPOBS, and nothing in this Agreement or in the parties'
              dealings arising out of or related to this Agreement will restrict
              EPOBS' right to use, profit from, disclose, publish, keep secret,
              or otherwise exploit Feedback, without compensating or crediting
              Customer or the User in question. Notwithstanding the provisions
              of Article VII below, Feedback will not be considered Confidential
              Information, provided information Customer transmits with Feedback
              or related to Feedback may be considered Confidential Information.
              ("Feedback" refers to any suggestions or ideas for improving or
              otherwise modifying any of EPOBS' products or services.)
            </li>
          </ol>
        </li>
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '17.36pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Confidential Information.
        </li>
      </ol>
      <p
        style={{
          marginLeft: '18pt',
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        "Confidential Information" refers to the following items EPOBS disclosed
        to Customer: (a) any document EPOBS marks "Confidential"; (b) any
        information EPOBS orally designates as "Confidential" at the time of
        disclosure, provided EPOBS confirms such designation in writing within
        five (5) business days; (c) the Documentation, whether or not marked or
        designated confidential; and (d) any other nonpublic, sensitive
        information Customer should reasonably consider a trade secret or
        otherwise confidential. Notwithstanding the foregoing, Confidential
        Information does not include information that: (i) is in Customer's
        possession at the time of disclosure; (ii) is independently developed by
        Customer without use of or reference to Confidential Information; (iii)
        becomes known publicly, before or after disclosure, other than as a
        result of Customer's improper action or inaction; or (iv) is approved
        for release in writing by Customer. Customer is on notice that the
        Confidential Information may include EPOBS' valuable trade secrets.
      </p>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginTop: '6pt',
            marginLeft: '28.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>Nondisclosure</u>
          </strong>
          . Customer: (a) shall not disclose Confidential Information to any
          employee or contractor of Customer unless such person executes a
          nondisclosure agreement with Customer with terms no less restrictive
          than those of this Article 7; and (b) shall not disclose Confidential
          Information to any other third party without EPOBS' prior written
          consent. Without limiting the generality of the foregoing, Customer
          shall protect Confidential Information with the same degree of care it
          uses to protect its own confidential information of a similar nature
          and importance, but with no less than reasonable care. Customer shall
          promptly notify EPOBS of any misuse or misappropriation of
          Confidential Information that comes to Customer's attention.
          Notwithstanding the foregoing, Customer may disclose Confidential
          Information as required by applicable law or by proper legal or
          governmental authority. Customer shall give EPOBS prompt notice of any
          such legal or governmental demand and reasonably cooperate with EPOBS
          in any effort to seek a protective order or otherwise to contest such
          required disclosure, at EPOBS' expense.
        </li>
        <li
          style={{
            marginLeft: '30.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>Injunction</u>
          </strong>
          . Customer agrees that breach of this nondisclosure clause{' '}
          <span style={{ color: '#ff0000' }}>&nbsp;</span>
          <span style={{ color: '#ff0000' }}>would&nbsp;</span>cause EPOBS
          irreparable injury, for which monetary damages would not provide
          adequate compensation, and that in addition to any other remedy, EPOBS
          will be entitled to injunctive relief against such breach or
          threatened breach, without proving actual damage or posting a bond or
          other security.
        </li>
        <li
          style={{
            marginLeft: '33.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Retention of Rights</u>
          </strong>
          . This Agreement does not transfer ownership of Confidential
          Information or grant a license thereto. EPOBS will retain all right,
          title, and interest in and to all Confidential Information.
        </li>
        <li
          style={{
            marginLeft: '33.27pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.73pt',
          }}
        >
          <strong>
            <u>Immunity</u>
          </strong>
          . An individual shall not be held criminally or civilly liable under
          any Ghanaian trade secret law for the disclosure of a trade secret
          that- (a) is made- (i) in confidence to a Regional, District, or local
          government official, either directly or indirectly, or to an attorney;
          and (ii) solely for the purpose of reporting or investigating a
          suspected violation of law; or (b) is made in a complaint or other
          document filed in a lawsuit or other proceeding, if such filing is
          made under seal.
        </li>
        <li
          style={{
            marginLeft: '30.75pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.25pt',
          }}
        >
          <strong>
            <u>Use of Trade Secret Information in Anti-Retaliation Lawsuit</u>
          </strong>
          . An individual who files a lawsuit for retaliation by an employer for
          reporting a suspected violation of law may disclose the trade secret
          to the attorney of the individual and use the trade secret information
          in a court proceeding, if the individual- (a) files any document
          containing the trade secret under seal; and (b) does not disclose the
          trade secret, except pursuant to court Order Form.
        </li>
      </ol>
      <ol
        start={5}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '14.34pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Representations &amp; Warranties.
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '28.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>From EPOBS</u>
          </strong>
          . EPOBS represents and warrants that it is the owner of the System,
          (‘EPOBS School Management System, Daily Fee Payment System and Parent
          App’) and of each component thereof, or the recipient of a valid
          license thereto, and that it has and will maintain the full power and
          authority to grant the rights granted in this Agreement without the
          further consent of any third party. EPOBS' representations and
          warranties in the preceding sentence do not apply to use of the System
          in combination with hardware or software not provided by EPOBS. In the
          event of a breach of the warranty in this Section V.1, EPOBS, at its
          own expense, shall promptly take the following actions: (a) secure for
          Customer the right to continue using the System; (b) replace or modify
          the System to make it not infringing; or (c) terminate the infringing
          features of the Service and refund to Customer any prepaid fees for
          such features, in proportion to the portion of the Term left after
          such termination. In conjunction with Customer's right to terminate
          for breach where applicable, the preceding sentence states EPOBS' sole
          obligation and liability, and Customer's sole remedy, for breach of
          the warranty in this Section 8.1 and for potential or actual
          intellectual property infringement by the System.
        </li>
      </ol>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;
      </p>
      <ol
        start={2}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '30.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>From Customer</u>
          </strong>
          . Customer represents and warrants that: (a) it has the full right and
          authority to enter into, execute, and perform its obligations under
          this Agreement and that no pending or threatened claim or litigation
          known to it would have a material adverse impact on its ability to
          perform as required by this Agreement; (b) it has accurately
          identified itself and it has not provided any inaccurate information
          about itself to or through the System; and (c) it is a corporation,
          the sole proprietorship of an individual 18 years or older, or another
          entity authorized to do business pursuant to applicable law.
        </li>
      </ol>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        &nbsp;&nbsp;&nbsp;&nbsp;
      </p>
      <ol
        start={3}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginLeft: '33.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Warranty Disclaimers</u>
          </strong>
          . CUSTOMER ACCEPTS THE SYSTEM "AS IS" AND AS AVAILABLE, WITH NO
          REPRESENTATION OR WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
          WITHOUT LIMITATION IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR
          A PARTICULAR PURPOSE, OR NON INFRINGEMENT OF INTELLECTUAL PROPERTY
          RIGHTS, OR ANY IMPLIED WARRANTY ARISING FROM STATUTE, COURSE OF
          DEALING, COURSE OF PERFORMANCE, OR USAGE OF TRADE. WITHOUT LIMITING
          THE GENERALITY OF THE FOREGOING: (a) EPOBS HAS NO OBLIGATION TO
          INDEMNIFY OR DEFEND CUSTOMER OR USERS AGAINST CLAIMS RELATED TO
          INFRINGEMENT OF INTELLECTUAL PROPERTY; (b) EPOBS DOES NOT REPRESENT OR
          WARRANT THAT THE SYSTEM WILL PERFORM WITHOUT INTERRUPTION OR ERROR;
          AND (c) EPOBS DOES NOT REPRESENT OR WARRANT THAT THE SYSTEM IS SECURE
          FROM HACKING OR OTHER UNAUTHORIZED INTRUSION OR THAT CUSTOMER DATA
          WILL BE PRIVATE OR SECURE.
        </li>
      </ol>
      <ol
        start={6}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '17.36pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Indemnification
        </li>
      </ol>
      <p
        style={{
          marginLeft: '18pt',
          marginBottom: '7.5pt',
          textAlign: 'justify',
          lineHeight: '115%',
        }}
      >
        Customer shall defend, indemnify, and hold harmless EPOBS and the EPOBS
        Associates (as defined below) against any "Indemnified Claim," meaning
        any third party claim, suit, or proceeding arising out of or related to
        Customer's alleged or actual use of, misuse of, or failure to use the
        System, including without limitation: (a) claims by Users or by
        Customer's employees, as well as by Customer's own customers; (b) claims
        related to unauthorized disclosure or exposure of personally
        identifiable information or other private information, including
        Customer Data; (c) claims related to infringement or violation of a
        copyright, trademark, trade secret, or privacy or confidentiality right
        by written material, images, logos or other content uploaded to the
        System through Customer's account, including without limitation by
        Customer Data; and (d) claims that the use of the System through
        Customer's account harasses, defames, or defrauds a third party or
        violates the CAN-Spam Act of 2003 or any other law or restriction on
        electronic advertising. Indemnified Claims include, without limitation,
        claims arising out of or related to EPOBS' negligence. Customer's
        obligations set forth in this Article 9 include retention and payment of
        attorneys and payment of court costs, as well as settlement at
        Customer's expense and payment of judgments. EPOBS will have the right,
        not to be exercised unreasonably, to reject any settlement or compromise
        that requires that it admit wrongdoing or liability or subjects it to
        any ongoing affirmative obligations. (The "EPOBS Associates" are EPOBS'
        officers, directors, shareholders, parents, subsidiaries, agents,
        successors, and assigns.)
      </p>
      <ol
        start={7}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '20.38pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Limitation Of Liability
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginTop: '6pt',
            marginLeft: '10.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>Cap</u>
          </strong>
          . EPOBS' LIABILITY ARISING OUT OF OR RELATED TO THIS AGREEMENT WILL
          NOT EXCEED THE AMOUNT OF FEES COLLECTED IN THE PRECEDING 6 (SIX)
          MONTHS.
        </li>
        <li
          style={{
            marginLeft: '12.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>Exclusion of Consequential Damages</u>
          </strong>
          . IN NO EVENT WILL EPOBS BE LIABLE TO CUSTOMER FOR ANY CONSEQUENTIAL,
          INDIRECT, SPECIAL, INCIDENTAL, OR PUNITIVE DAMAGES ARISING OUT OF OR
          RELATED TO THIS AGREEMENT.
        </li>
        <li
          style={{
            marginLeft: '15.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Clarifications &amp; Disclaimers</u>
          </strong>
          . THE LIABILITIES LIMITED BY THIS ARTICLE VII APPLY: (a) TO LIABILITY
          FOR NEGLIGENCE; (b) REGARDLESS OF THE FORM OF ACTION, WHETHER IN
          CONTRACT, TORT, STRICT PRODUCT LIABILITY, OR OTHERWISE; (c) EVEN IF
          EPOBS IS ADVISED IN ADVANCE OF THE POSSIBILITY OF THE DAMAGES IN
          QUESTION AND EVEN IF SUCH DAMAGES WERE FORESEEABLE; AND (d) EVEN IF
          CUSTOMER'S REMEDIES FAIL OF THEIR ESSENTIAL PURPOSE. If applicable law
          limits the application of the provisions of this Article VII, EPOBS'
          liability will be limited to the maximum extent permissible. For the
          avoidance of doubt, EPOBS' liability limits and other rights set forth
          in this Article 10 apply likewise to EPOBS' affiliates, licensors,
          suppliers, advertisers, agents, sponsors, directors, officers,
          employees, consultants, and other representatives.
        </li>
      </ol>
      <ol
        start={8}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '23.41pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Term
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginTop: '6pt',
            marginLeft: '10.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>Term</u>
          </strong>
          . The term of this Agreement (the "Term") will commence on the date
          the Customer subscribes to or executes the End User License Agreement
          or submits an Order Form (the "Effective Date") and continue for the
          period set forth in the End User License Agreement or Order Form
          ("Initial Term"). Thereafter, the Term will renew for successive
          periods of the same length of the Initial Term, unless either party
          refuses such renewal by written notice thirty (30) or more days prior
          to the expiration of the then-current term.
        </li>
        <li
          style={{
            marginLeft: '12.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>Termination for Cause</u>
          </strong>
          . Either party may terminate this Agreement for the other's material
          breach by written notice specifying in detail the nature of the
          breach, effective in 30 days unless the other party first cures such
          breach, or effective immediately if the breach is not subject to cure.
        </li>
        <li
          style={{
            marginLeft: '15.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Effects of Termination</u>
          </strong>
          . Upon termination of this Agreement, Customer shall cease all use of
          the System and delete, destroy, or return all copies of the
          Documentation in its possession or control. The following provisions
          will survive termination or expiration of this Agreement: (a) any
          obligation of Customer to pay fees incurred before termination; (b)
          Articles 1 and Sections III (IP &amp; Feedback), IV (Confidential
          Information), V (Representations and Warranty), VI (Indemnification),
          and VII (Limitation of Liability); and (c) any other provision of this
          Agreement that must survive to fulfill its essential purpose.
        </li>
      </ol>
      <p>&nbsp;</p>
      <ol
        start={9}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '16.78pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Miscellaneous.
        </li>
      </ol>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'lower-roman',
        }}
      >
        <li
          style={{
            marginTop: '6pt',
            marginLeft: '28.3pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '7.7pt',
          }}
        >
          <strong>
            <u>Independent Contractors</u>
          </strong>
          . The parties are independent contractors and shall so represent
          themselves in all regards. Neither party is the agent of the other,
          and neither may make commitments on the other's behalf.
        </li>
        <li
          style={{
            marginLeft: '30.83pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.17pt',
          }}
        >
          <strong>
            <u>Force Majeure</u>
          </strong>
          . No delay, failure, or default, other than a failure to pay fees when
          due, will constitute a breach of this Agreement to the extent caused
          by acts of war, terrorism, hurricanes, earthquakes, other acts of God
          or of nature, strikes or other labor disputes, riots or other acts of
          civil disorder, embargoes, or other causes beyond the performing
          party's reasonable control.
        </li>
        <li
          style={{
            marginLeft: '33.35pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.65pt',
          }}
        >
          <strong>
            <u>Assignment &amp; Successors</u>
          </strong>
          . Customer may not assign this Agreement or any of its rights or
          obligations hereunder without EPOBS' express written consent. Except
          to the extent forbidden in this Section IX(iv), this Agreement will be
          binding upon and inure to the benefit of the parties' respective
          successors and assigns.
        </li>
        <li
          style={{
            marginLeft: '33.27pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.73pt',
          }}
        >
          <strong>
            <u>Severability</u>
          </strong>
          . To the extent permitted by applicable law, the parties hereby waive
          any provision of law that would render any clause of this Agreement
          invalid or otherwise unenforceable in any respect. If a provision of
          this Agreement is held to be invalid or otherwise unenforceable, such
          provision will be interpreted to fulfill its intended purpose to the
          maximum extent permitted by applicable law, and the remaining
          provisions of this Agreement will continue in full force and effect.
        </li>
        <li
          style={{
            marginLeft: '30.75pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '5.25pt',
          }}
        >
          <strong>
            <u>No Waiver</u>
          </strong>
          . Neither party will be deemed to have waived any of its rights under
          this Agreement by lapse of time or by any statement or representation
          other than by an authorized representative in an explicit written
          waiver. No waiver of a breach of this Agreement will constitute a
          waiver of any other breach of this Agreement.
        </li>
        <li
          style={{
            marginLeft: '33.27pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.73pt',
          }}
        >
          <strong>
            <u>Choice of Law &amp; Arbitration</u>
          </strong>
          : This Agreement and all claims arising out of or related to this
          Agreement will be governed solely by the internal laws of the Republic
          of Ghana, including without limitation applicable Ghanaian laws. In
          the event of a dispute under this Agreement, the parties agree to
          arbitration under the Commercial Rules of the Ghanaian Arbitration.
          This Section vi governs all claims arising out of or related to this
          Agreement, including without limitation tort claims.
        </li>
        <li
          style={{
            marginLeft: '35.79pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '0.21pt',
          }}
        >
          <strong>
            <u>Technology Export</u>
          </strong>
          . Customer shall not: (a) permit any third party to access or use the
          System in violation of any Ghanaian law or regulation; or (b) export
          any software provided by EPOBS or otherwise remove it from Ghana
          except in compliance with all applicable Ghanaian laws and
          regulations. Without limiting the generality of the foregoing,
          Customer shall not permit any third party to access or use the System
          without EPOBS express permission.
        </li>
        <li
          style={{
            marginLeft: '36pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
          }}
        >
          <strong>
            <u>Entire Agreement</u>
          </strong>
          . This Agreement sets forth the entire agreement of the parties and
          supersedes all prior or contemporaneous writings, negotiations, and
          discussions with respect to its subject matter. Neither party has
          relied upon any such prior or contemporaneous communications.
        </li>
        <li
          style={{
            marginLeft: '33.07pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            lineHeight: '115%',
            paddingLeft: '2.93pt',
          }}
        >
          <strong>
            <u>Amendment</u>
          </strong>
          . EPOBS may amend this Agreement from time to time by posting an
          amended version on its&nbsp; Website and sending Customer written
          notice thereof. Such an amendment will be deemed accepted and become
          effective 30 days after such notice (the "Proposed Amendment Date")
          unless Customer first gives EPOBS written notice of rejection of the
          amendment. In the event of such rejection, this Agreement will
          continue under its original provisions, and the amendment will become
          effective at the start of Customer's next Term following the Proposed
          Amendment Date (unless Customer first terminates this Agreement
          pursuant to Article 11, Term &amp; Termination). Customer's continued
          use of the Service following the effective date of an amendment will
          confirm Customer's consent thereto. This Agreement may not be amended
          in any other way except through a written agreement by authorized
          representatives of each party. Notwithstanding the foregoing
          provisions of this Section ix, EPOBS may revise the Privacy Policy and
          Acceptable Use Policy at any time by posting a new version of either
          at the Website, and such new version will become effective on the date
          it is posted.
        </li>
      </ol>
      <ol
        start={10}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '13.76pt',
            marginBottom: '0pt',
            textAlign: 'justify',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Unsolicited Idea Submission Policy
        </li>
      </ol>
      <p
        style={{
          marginLeft: '36pt',
          marginBottom: '0pt',
          textAlign: 'justify',
          backgroundColor: '#ffffff',
        }}
      >
        EPOBS SOLUTIONS OR ANY OF ITS EMPLOYEES DO NOT ACCEPT OR CONSIDER
        UNSOLICITED IDEAS, INCLUDING IDEAS FOR NEW ADVERTISING CAMPAIGNS, NEW
        PROMOTIONS, NEW PRODUCTS OR TECHNOLOGIES, PROCESSES, MATERIALS,
        MARKETING PLANS OR NEW PRODUCT NAMES. PLEASE DO NOT SEND ANY ORIGINAL
        CREATIVE ARTWORK, SAMPLES, DEMOS, OR OTHER WORKS. THE SOLE PURPOSE OF
        THIS POLICY IS TO AVOID POTENTIAL MISUNDERSTANDINGS OR DISPUTES WHEN
        EPOBS SOLUTION'S PRODUCTS OR MARKETING STRATEGIES MIGHT SEEM SIMILAR TO
        IDEAS SUBMITTED TO EPOBS SOLUTIONS. SO, PLEASE DO NOT SEND YOUR
        UNSOLICITED IDEAS TO EPOBS SOLUTIONS OR ANYONE AT EPOBS SOLUTIONS. IF,
        DESPITE OUR REQUEST THAT YOU DO NOT SEND US YOUR IDEAS AND MATERIALS,
        YOU STILL SEND THEM, PLEASE UNDERSTAND THAT EPOBS SOLUTIONS MAKES NO
        ASSURANCES THAT YOUR IDEAS AND MATERIALS WILL BE TREATED AS CONFIDENTIAL
        OR PROPRIETARY.
      </p>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'justify',
          backgroundColor: '#ffffff',
        }}
      >
        &nbsp;
      </p>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'justify',
          backgroundColor: '#ffffff',
        }}
      >
        &nbsp;
      </p>
      <h1>PRIVACY POLICY</h1>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'center',
          lineHeight: 'normal',
          fontSize: '18pt',
        }}
      >
        &nbsp;
      </p>
      <p style={{ textAlign: 'justify' }}>
        Your privacy is important to us. This privacy statement explains the
        personal data Epobs processes, how Epobs processes it, and for what
        purposes.
      </p>
      <p style={{ textAlign: 'justify' }}>
        This Privacy Policy describes the way Epobs Solutions Ghana Ltd. and its
        affiliates (collectively, "Epobs Solutions" or "us") obtains, uses,
        stores, manages, and disposes of certain information that you, as a user
        of our services, provide to us. You have certain rights, described
        below, to know what information we collect, how we use it, and how you
        may obtain and correct it.
      </p>
      <p style={{ textAlign: 'justify' }}>
        EPOBS first collects information about you and about your Institution
        and/or Organization. When you provide information to EPOBS, through our
        SMS or otherwise, you are warranting to Epobs Solutions that all the
        information you provide to us about yourself and about your Institution
        and/or Organization is accurate and complete. EPOBS is relying on your
        warranty when EPOBS provides the Service to you. The information you
        provide includes Personally Identifiable Information, which is defined
        as information that can be used on its own or with other information, to
        identify you.&nbsp;
      </p>
      <p style={{ textAlign: 'justify' }}>
        In addition to the information you provide, EPOBS may have, or may
        obtain from third parties, information about you or your Institution
        and/or Organization, some of which may be Personally Identifiable
        Information. More information about these third parties appears below.
        EPOBS uses this information to provide its services to you, and to help
        protect you, the EPOBS service, your Institution and/or Organization and
        the general public from mistakes, fraud, money-laundering and other
        problems.&nbsp;&nbsp;&nbsp;&nbsp;
      </p>
      <ol
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '11.05pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '8.5pt',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Collection of Information
        </li>
      </ol>
      <p
        style={{
          marginLeft: '18pt',
          textAlign: 'justify',
          lineHeight: '108%',
          fontSize: '12pt',
        }}
      >
        <span style={{ lineHeight: '108%', fontSize: '11pt' }}>
          The initial information we collect from you includes information about
          yourself, such as your full legal name, address, date of birth,
          telephone number, email address, as well as other information and/or
          documentation that will allow us to verify your identity. You must
          also provide us with information about your Institution and/or
          Organization, which may include sensitive personal information such as
          your Institution and/or Organization's name, address, mobile phone
          number and/or bank account information. EPOBS may also collect
          information from your system or other device from which you access the
          EPOBS App, including your IP (Internet Protocol) address, operating
          system, device identification information, and other information
          associated with your access to and use of the App. EPOBS may also
          collect information about the websites you have visited prior to
          accessing the EPOBS service. EPOBS may keep and store&nbsp;
        </span>
        such{' '}
        <span style={{ lineHeight: '108%', fontSize: '11pt' }}>
          information and associate it with your use, to help identify you and
          facilitate your use of our service in the future.
        </span>
        <span style={{ lineHeight: '108%', fontSize: '11pt' }}>
          &nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </p>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        When you access the EPOBS app, EPOBS may collect and store information
        regarding your use of the App and the service. This includes information
        about the frequency with which you access the App, the time you spend
        there, the way you move through the site, your activity history, and any
        other details we may deem fit.
      </p>
      <ol
        start={2}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '14.08pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '8.5pt',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Use of Information
        </li>
      </ol>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        EPOBS may maintain and use all of the information and documentation that
        you provide, as well as information that we derive from your use of the
        service, and the information that we obtain about you from third
        parties, in order to provide the EPOBS service to you, and to enable
        EPOBS to comply with laws and regulations, including those intended to
        prevent fraud, money laundering, and other abuses of the financial
        system. EPOBS may use your information to contact you as necessary to
        confirm or complete a transaction, and to allow our agents, partners,
        and service providers to fulfill their obligations in providing the
        EPOBS service to you. EPOBS may also use your information to improve our
        service, to troubleshoot problems, to develop new products and services,
        and to create advertising, marketing, and promotional campaigns. (More
        information about EPOBS's use of your data for marketing and promotion
        is below). EPOBS may disclose your information to third parties,
        including government agencies, when EPOBS reasonably determines that
        such disclosure is required by law, such as responses to subpoenas and
        information requests by law enforcement, financial services regulators,
        or national security authorities.
      </p>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        EPOBS will not sell, rent, or otherwise disclose your information to
        third party marketers or others unaffiliated with EPOBS for the purpose
        of advertising, promoting, or selling other services to you. However,
        where and to the extent allowed by law, EPOBS may work with third
        parties to analyze the information that we gather from you when you
        visit us on-line, including our website, our Facebook page, and our
        Facebook advertisements, whether you use the EPOBS service. EPOBS may
        use the information we gather there, along with the information we
        obtain from your use of our service, which may include Personally
        Identifiable Information, to advertise and promote EPOBS services to you
        and to others. For example, EPOBS provides data to Facebook’s.
      </p>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        Ad Manager account and SDK programs, which provide us with information
        about the way customers and other visitors access, view and use the
        EPOBS website and application.
      </p>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        Finally, we use that information to create advertisements and
        promotions; such advertisements and promotions may appear in your
        Facebook feed or on other sites owned or operated by Facebook, such as
        Instagram. We may customize our marketing and promotional messages to
        you based on your use of our service, the information that you provide
        to us or which we otherwise obtain about you, and algorithms designed to
        help us anticipate your potential needs, based on your information and
        the information of others who use EPOBS services. EPOBS believes that
        such programs provide valuable information and benefits to our current
        and potential users. However, if you live in the European Community or
        another jurisdiction where such use of your data for marketing and
        promotional purposes requires your permission, EPOBS will not use your
        data for these purposes unless you "opt in" to such uses.
      </p>
      <ol
        start={3}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '17.1pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '8.5pt',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Protection of personal information collected by EPOBS
        </li>
      </ol>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        EPOBS's leading security experts and practices help ensure that your
        Personally Identifiable Information is secure. All such information is
        stored on servers with state-of-the- art data protection technology, and
        is accessible only to EPOBS employees who, for business purposes, need
        to access it. We use 128-bit encryption and encode your debit card
        information as soon as it is entered in the EPOBS website, a process
        that overwrites your details so that they are unreadable by unauthorized
        parties.
      </p>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        No method of transmission over the Internet, or method of electronic
        storage, is 100% secure, however. Although EPOBS uses strong methods to
        protect the data that you provide to us, and we regularly test our
        information protection practices and technology, EPOBS cannot absolutely
        guarantee its security. We will, however, notify you of any breach or
        other compromise that affects your data, promptly and in compliance with
        applicable laws.
      </p>
      <ol
        start={4}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '17.86pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '8.5pt',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Use of Cookies and other Tracking Devices
        </li>
      </ol>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        EPOBS uses "cookies" and other tracking devices to help us recognize
        you, remember your preferences and facilitate your future transactions
        and other interactions with us. We also use such tracking devices to
        help us understand consumer behavior on our App, to help us improve it
        and make it easier for future use. You may be able to disable your
        device's use of cookies, but that may slow or prevent your ability to
        use the EPOBS service.
      </p>
      <ol
        start={5}
        style={{
          margin: '0pt',
          paddingLeft: '0pt',
          listStyleType: 'upper-roman',
        }}
      >
        <li
          style={{
            marginTop: '12pt',
            marginLeft: '14.84pt',
            marginBottom: '0pt',
            pageBreakInside: 'avoid',
            pageBreakAfter: 'avoid',
            lineHeight: '108%',
            paddingLeft: '8.5pt',
            fontSize: '12pt',
            color: '#2f5496',
          }}
        >
          Privacy Policy Changes
        </li>
      </ol>
      <p style={{ marginLeft: '18pt', textAlign: 'justify' }}>
        EPOBS's privacy policy may change in the future. If that happens, the
        revised version will be posted on our website,{' '}
        <a
          href="http://www.epobssolutions.com"
          style={{ textDecoration: 'none' }}
        >
          <u>
            <span style={{ color: '#0563c1' }}>www.epobssolutions.com</span>
          </u>
        </a>{' '}
        , and will be sent to current users via the email addresses associated
        with their EPOBS App accounts.
      </p>
      <p
        style={{
          marginBottom: '0pt',
          textAlign: 'justify',
          backgroundColor: '#ffffff',
        }}
      >
        &nbsp;
      </p>
      <p>&nbsp;</p>
      <p style={{ bottom: 10, right: 10, position: 'absolute' }}>
        <a
          href="https://wordtohtml.net"
          target="_blank"
          style={{ fontSize: 11, color: '#d0d0d0' }}
          rel="noreferrer"
        >
          Converted to HTML with WordToHTML.net
        </a>
      </p>
    </>
  );
}
